<template>
  <div>
    <vs-button
      radius
      color="primary"
      type="gradient"
      icon="link"
      v-tooltip="'Integrações'"
      class="d-inline"
      @click="abrirModal"
    ></vs-button>

    <vs-popup
      title="Integrações"
      :active.sync="modalAtiva"
      @close="modalAtiva = false"
      class="w-full"
    >
      <vs-tabs alignment="fixed">
        <vs-tab label="ActiveCampaign">
          <div v-if="loadingIntegracao" class="text-center py-4">
            Carregando...
          </div>

          <div v-else-if="!integrationLoaded" class="text-center">
            <p>Você ainda não integrou com o ActiveCampaign.</p>
            <vs-button
              color="success"
              class="mt-3"
              @click="integrationLoaded = true"
            >
              Iniciar Integração
            </vs-button>
          </div>

          <div v-else class="vx-row">
            <div class="vx-col w-full mb-4">
              <label>URL</label>
              <vs-input
                v-model="activeCampaignIntegracao.client_id"
                class="w-full"
              />
            </div>

            <div class="vx-col w-full mb-4">
              <label>Chave - Token</label>
              <vs-input
                v-model="activeCampaignIntegracao.access_token"
                type="password"
                class="w-full"
              />
            </div>

            <div class="vx-col w-full mt-2">
              <vs-button
                color="success"
                class="btn-success"
                @click="salvarIntegracaoActiveCampaign"
              >
                Salvar Integração
              </vs-button>
            </div>
          </div>
        </vs-tab>
      </vs-tabs>
    </vs-popup>
  </div>
</template>

<script>
import service from "@/services";
import jwt from "jsonwebtoken";

export default {
  name: "FormIntegrations",
  data() {
    return {
      modalAtiva: false,
      idEmpresa: null,
      integrationLoaded: false,
      loadingIntegracao: false,
      activeCampaignIntegracao: {
        client_id: "",
        access_token: "",
        integrationName: "activecampaign",
        idEmpresa: null,
      },
    };
  },
  methods: {
    async abrirModal() {
      this.modalAtiva = true;

      try {
        const decoded = jwt.decode(localStorage.getItem("user-token"));
        this.idEmpresa = decoded.idEmpresa || null;

        if (!this.idEmpresa) throw new Error("ID da empresa não encontrado");

        await this.carregarIntegracaoActiveCampaign();
      } catch (e) {
        this.$vs.notify({
          title: "Erro",
          text: e.message || "Erro ao abrir modal",
          color: "danger",
        });
      }
    },

    async carregarIntegracaoActiveCampaign() {
      this.loadingIntegracao = true;
      try {
        const res = await service.getParams("Integration", "integration", {
          idEmpresa: this.idEmpresa,
          integrationName: "activecampaign",
        });

        const data = res.data || {};

        this.activeCampaignIntegracao = {
          idEmpresa: this.idEmpresa,
          integrationName: "activecampaign",
          client_id: data.client_id || "",
          access_token: data.access_token || "",
        };

        this.integrationLoaded = !!data.client_id;
      } catch (err) {
        console.warn("Erro ao carregar integração:", err);
        this.integrationLoaded = false;
      } finally {
        this.loadingIntegracao = false;
      }
    },

    salvarIntegracaoActiveCampaign() {
      if (
        !this.activeCampaignIntegracao.client_id ||
        !this.activeCampaignIntegracao.access_token
      ) {
        this.$vs.notify({
          title: "Atenção",
          text: "Preencha os campos obrigatórios.",
          color: "warning",
        });
        return;
      }

      const payload = {
        idEmpresa: this.idEmpresa,
        integrationName: "activecampaign",
        client_id: this.activeCampaignIntegracao.client_id,
        access_token: this.activeCampaignIntegracao.access_token,
        refresh_token: null,
      };

      service
        .post("Integration", "integration", payload)
        .then(() => {
          this.integrationLoaded = true;
          this.$vs.notify({
            title: "Sucesso",
            text: "Integração salva com sucesso.",
            color: "success",
          });
        })
        .catch(() => {
          this.$vs.notify({
            title: "Erro",
            text: "Erro ao salvar integração.",
            color: "danger",
          });
        });
    },
  },
};
</script>
